import { useEffect } from "react";

export default function ButtonPrimary({ text, href, type }) {
  var setScrolled = false;

  useEffect(() => {
    const handleScroll = () => setScrolled = window.scrollY > 50;
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const target = document.getElementById(targetId);

    if (target) {
      setTimeout(() => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.pushState(null, "", `#${targetId}`);
      }, 0);
    }

  };

  useEffect(() => {
    const hash = window.location.hash.substr(1);
    if (hash) {
      setTimeout(() => handleSmoothScroll(new Event("click"), hash), 100);
    }
  }, []);

  const getButtonClasses = () => {
    const redButtonStyles =
      "mt-8 flex items-center px-8 py-4 text-md border border-red-600 text-red-600 font-semibold rounded-lg hover:bg-red-600 hover:text-white transition-all duration-300 shadow-lg hover:-translate-y-2";
    const secondButtonSyle = "mt-8 flex items-center px-8 py-4 text-md border border-red-600  font-semibold rounded-lg hover:-translate-y-2 bg-red-600 text-white transition-all duration-300 shadow-lg";
    switch (type) {
      case "primary":
        return secondButtonSyle;
      case "second":
        return redButtonStyles;
      default:
        return redButtonStyles;
    }
  };

  return (
    <button onClick={(e) => handleSmoothScroll(e, href)} className={getButtonClasses()}>
      {text}
    </button>
  );
}
